import { useMutation, useQueryClient } from 'react-query'
import { request } from 'Features/auth/axios-client'
import {
  PlanDataTypes,
  UseCreateOperationalPlanTypes,
} from 'Features/OperationalPlanner/OperationalPlanner.types'

const createOperationalPlanV2 = async (planData: PlanDataTypes) => {
  const { data } = await request({
    url: '/operational-plan-v2',
    data: planData,
    method: 'post',
  })
  return data
}

export const useCreateOperationalPlanV2 = ({
  onSuccessfulPlanCreation,
  onFailedPlanCreation,
}: UseCreateOperationalPlanTypes) => {
  const queryClient = useQueryClient()
  return useMutation(createOperationalPlanV2, {
    onSuccess: async (data) => {
      await queryClient.invalidateQueries(['operational-plans'])
      onSuccessfulPlanCreation(
        data?.data?.plan_id,
        data?.data?.unconstrainedPlan
      )
    },
    onError: async () => {
      await queryClient.invalidateQueries(['operational-plans'])
      onFailedPlanCreation()
    },
  })
}
